var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.componentName,{tag:"component",staticClass:"fill-current",class:[
    { rotate: _vm.rotate },
    _vm.classes,
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }